import { useMemo } from 'react';
import * as Location from 'expo-location';

import { fromPromise } from 'xstate5';

import type { RequestLocationPermissionOutput } from '../../permissions.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const useRequestLocationPermissionActor = () => {
  return useMemo(
    () =>
      fromPromise<RequestLocationPermissionOutput>(async () =>
        Location.requestForegroundPermissionsAsync(),
      ),
    [],
  );
};
